import React from 'react';
import Paper from '@material-ui/core/Paper';

export const PaperWidget = ({ width = "100px", height, children, className }) => {

    const style = ({
        width: width,
    });
    const props = { style }
    return <Paper className={className} elevation={1} {...props} >
        {children}
    </Paper>
};

export default PaperWidget;
